import { memo, MouseEvent, ReactNode } from 'react'
import cn from 'classnames'

interface IProps {
  children?: ReactNode
  className?: string
  onClick?: (event: MouseEvent<HTMLDivElement>) => void
  testId?: string
}

export const ListRow = memo(function ListRow({ children, className, onClick, testId }: IProps) {
  return (
    <div
      data-name="tableRow"
      data-test-id={testId}
      onClick={onClick}
      className={cn(
        'relative flex w-full items-center break-words bg-surface	px-4 py-3',
        {
          'after:bg-repeat-[no-repeat] before:bg-repeat-[no-repeat] cursor-pointer before:pointer-events-none before:absolute before:bottom-[100%] before:left-0 before:h-[6px] before:w-full before:content-[""] before:[background-position:0_6px] after:pointer-events-none after:absolute after:left-0 after:top-[100%] after:h-2 after:w-full after:content-[""] after:[background-position:0_-8px] hover:z-[2] hover:before:bg-[linear-gradient(to_bottom,transparent,rgb(26,28,30,0.06))_0_0] hover:after:bg-[linear-gradient(to_top,transparent,rgb(26,28,30,0.06))_0_0]':
            onClick
        },
        className
      )}
    >
      {children}
    </div>
  )
})
